import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, LineController, LineElement, PointElement, LinearScale, Title, CategoryScale } from 'chart.js';
import { Link } from "remix";
import { Carousel, Tabs } from "../components/carousel.jsx";
import { MainMenu } from '~/components/menus.js';

ChartJS.register(LinearScale, LineController, LineElement, PointElement, CategoryScale, Title);

const chartConfig = {
  type: 'bar',
  data: {
      labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
      datasets: [{
          label: '# of Votes',
          data: [12, 19, 3, 5, 2, 3],
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          // backgroundColor: 'rgba(0,0,0)',
          // lineColor:'rgba(130,90,30)',
          // borderColor: 'rgba(255, 99, 132, 1)',
          // borderWidth: 1
      }]
  },
  options: {
      scales: {
          y: {
              beginAtZero: true
          }
      }
  }
};

export default function Index() {
  return (
    <div style={{ fontFamily: "system-ui, sans-serif", lineHeight: "1.4" }}>
      <h1>Welcome to Remix</h1>
      <Link to="/youtube">YouTube</Link>
      <div>
        <MainMenu />
        </div>
    </div>
  );
}
